import React from 'react';
import { useSelector } from 'react-redux';
import Dictionary from '../static/data/Dictionary';

export const useTranslate = () => {
    const strongOpeningKeyword = '<strong>';
    const strongClosingKeyword = '</strong>';

    const appTexts = useSelector((state: any) => {
        return state?.Texts?.texts;
    });

    // support for <strong></strong> tags in translations
    const replaceStrong = (text: string) =>
        text
            .split(strongOpeningKeyword)
            .map((segment) =>
                segment
                    .split(strongClosingKeyword)
                    .map((subSegment, index, array) =>
                        array.length === 2 && index === 0 ? <strong>{subSegment}</strong> : subSegment
                    )
            )
            .flat();

    return (
        key: keyof typeof Dictionary.norsk | string, //it is possible to use translate if only some values have corresponding keys in the dictionary
        values?: Record<string, string | number>,
        isTrackLinkname?: boolean
    ) => {
        const translatedText = appTexts.get(key, values, isTrackLinkname);
        return translatedText.includes(strongOpeningKeyword) ? replaceStrong(translatedText) : translatedText;
    };
};
